<template>
	<div class="full">
		<vxe-grid v-bind="gridOptions" v-if="gridOptions" :loading="loading" ref="purchasevoucherDetail" ></vxe-grid>
	</div>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			componentStore: {
				default: () => {
					return null
				}
			},
			item: {
				type: Object,
				default: () => {
					return {}
				}
			},
			ordertypeMap: {
				type: Object,
				default: () => {
					return {}
				}
			},
			currentRow: {
				default: () => {
					return null
				}
			},
			toolbarButtonConfig: {
				default: () => {
					return []
				}
			},
			toolbarButtonList: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				loading: false,
				gridOptions: null,
				toolbarButton:[],
				detail:[]
			}
		},
		watch: {
			currentRow(e) {
				if (e) {
					this.$api.purchasevoucher.getDetail({id:e.id}).then((res) => {
						this.$refs.purchasevoucherDetail.reloadData(res)
					})
				} else {
					this.$refs.purchasevoucherDetail.reloadData([])
				}
			},
			// toolbarButtonConfig(){
			// 	this.getToolbarButton()
			// }
		},
		computed: {

		},
		created() {

		},
		mounted() {
			this.gridOptions = this.getOption()	

		},
		methods: {
			getOption() {
				return {
					id: 'purchasevoucherDetail',
					border: true,
					size: 'mini',
					columns: this.getColumns(),
					columnConfig: {
						isHover: false,
						resizable: true
					},
					customConfig: {
						storage: true
					},
					cellStyle:this.cellStyle,
					toolbarConfig: {
						size: 'mini',
						perfect: false,
						buttons: this.toolbarButton,
						zoom:true,
						customConfig: {
							storage: true
						},
					},
					rowConfig: {
						isHover: true,
						isCurrent: true,
					},
				
					showOverflow: true,
					height: 'auto',
					pagerConfig: {
						enable: false
					},
					proxyConfig: {},
					sortConfig: {
						remote: false
					}
				}
			},
			getColumns() {
				return [{
					title: '#',
					type: 'seq',
					width: 30
				}, {
					field: 'barCode',
					title: '商品编码',
					width: 120
				}, 
				// {
				// 	field: 'status',
				// 	title: '状态',
				// 	formatter:this.wlnpurchasestatusFormatter
				// }, 
				{
					field: 'goodsName',
					title: '商品名称'
				}, {
					field: 'skuName',
					title: '规格名称'
				}, {
					field: 'unitName',
					title: '单位'
				}, {
					field: 'size',
					title: '数量'
				}, {
					field: 'needReturnNum',
					title: '已入库数量'
				}, {
					field: 'sum',
					title: '总价'
				}, {
					field: 'articleNumber',
					title: '货号'
				}, {
					field: 'remark',
					title: '备注'
				}]
			},

			takeStatus({
				cellValue
			}){
				if(cellValue==0){
					return '未提货'
				}else{
					return '已提货'
				}
			},
			wlnpurchasestatusFormatter({
				cellValue
			}) {
				let purchasegoodsMap = {
					'0': 8107,
					'1': 8110,
					'2': 8109,
					'3': 8111,
					'99': 8964
				}
				return window.systemMethods.getEmunValue('wlnpurchasestatus', purchasegoodsMap[cellValue])
			},
			cellStyle({
				row,
				column
			}) {
				if (row.grabstatus == 8113) {
					return {
						backgroundColor: 'rgb(233, 233, 235)'
					}
				}
				if (column.field == 'status') {
					if (row.status == 0) {
						return {
							color: '#F56C6C'
						}
					}
					if (row.status == 1) {
						return {
							color: '#409EFF'
						}
					}
					if (row.status == 2) {
						return {
							color: '#67C23A'
						}
					}
				}
				if (column.field == 'takeStatus') {
					if (row.takeStatus == 0) {
						return {
							color: '#F56C6C'
						}
					}else  {
						return {
							color: '#67C23A'
						}
					}
				}
			},
		},
		components: {
			
		}
	}
</script>